module.exports = __webpack_public_path__ + "static/media/pms.ffaf5e16.png";